import { AccountState } from "core/auth/auth.entity";

export const MIN_ORDER_PRICE_FOR_INVOICE = 50000000;

export const docsStateLabels = (state: AccountState) => {
  switch (state) {
    case AccountState.AwaitingVerification:
      return {
        label: "در انتظار بررسی",
        color: "orange",
      };
    case AccountState.DocsRejected:
      return {
        label: "رد شده",
        color: "#F74455",
      };
    default:
      return {
        label: "-",
        color: "black",
      };
  }
};

export const rejectionReasonsErrors = {
  "100": "شمارۀ اقتصادی نیاز به ویرایش دارد.",
  "101": "شناسه ملی نیاز به ویرایش دارد.",
  "102": "فایل آگهی تاسیس نیاز به ویرایش دارد.",
  "103": "فایل آگهی تغییرات نیاز به ویرایش دارد.",
  "104": "فایل مجوز فعالیت نیاز به ویرایش دارد.",
};
